var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://www.patreon.com/carlbot/membership","target":"_blank"}},[_c('b-button',{staticClass:"premium-cta patreon-btn",attrs:{"size":"lg"},on:{"click":_vm.trackPremiumCTA}},[_c('img',{staticClass:"cta-svg-icon mr-2",attrs:{"src":"/img/brand/patreon-symbol-white.svg","alt":"Patreon"}}),_vm._v(" Buy on Patreon ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }